import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const tmmEditorSliceName = "tmmEditorSlice";

export interface TmmEditorState {
  targetId: string | undefined;
}

export interface ChangeParam {
  targetId: string | undefined;
}

export type TmmEditorRootState = { [tmmEditorSliceName]: TmmEditorState };

const initialState: TmmEditorState = { targetId: undefined };

const tmmEditorSlice = createSlice({
  name: tmmEditorSliceName,
  initialState,
  reducers: {
    changeTmmEditorTargetId: (state, action: PayloadAction<ChangeParam>) => {
      state.targetId = action.payload.targetId;
    },
  },
});

export const selectTargetId = (state: TmmEditorRootState) => state[tmmEditorSliceName].targetId;

export const { changeTmmEditorTargetId } = tmmEditorSlice.actions;
export const tmmEditorReducer = tmmEditorSlice.reducer;
